import script from "./OfNavBarTop.vue?vue&type=script&setup=true&lang=js"
export * from "./OfNavBarTop.vue?vue&type=script&setup=true&lang=js"

import "./OfNavBarTop.vue?vue&type=style&index=0&id=1a8f3ef5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8f3ef5"]])

export default __exports__